export const msToHoursMins = (date) => {
  const newDate =
    (new Date(date * 1000).getDate() < 10 ? "0" : "") +
    new Date(date * 1000).getDate() +
    "." +
    (new Date(date * 1000).getMonth() + 1 < 10 ? "0" : "") +
    (new Date(date * 1000).getMonth() + 1)
  return newDate
}
